import { bindActionCreators as reduxBindActionCreators } from 'redux'

/**
 * curried version of Redux's bindActionCreators
 *
 * @template {import('redux').ActionCreator} A
 * @param {A} obj
 * @returns {(dispatch: import('redux').Dispatch) => A}
 */
function bindActionCreators(obj) {
  return dispatch => reduxBindActionCreators(obj, dispatch)
}

export default bindActionCreators



// WEBPACK FOOTER //
// ./src/lib/utils/bindActionCreators.js